import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const administratorsRequest = createRequest(constants.administrators);
export const administratorsSuccess = createSuccess(constants.administrators);
export const administratorsFailure = createFailure(constants.administrators);

export const administratorRequest = createRequest(constants.administrator);
export const administratorSuccess = createSuccess(constants.administrator);
export const administratorFailure = createFailure(constants.administrator);

export const createAdministratorRequest = createRequest(constants.createAdministrator);
export const createAdministratorSuccess = createSuccess(constants.createAdministrator);
export const createAdministratorFailure = createFailure(constants.createAdministrator);

export const updateAdministratorRequest = createRequest(constants.updateAdministrator);
export const updateAdministratorSuccess = createSuccess(constants.updateAdministrator);
export const updateAdministratorFailure = createFailure(constants.updateAdministrator);

export const updateAdministratorStatusRequest = createRequest(constants.updateAdministratorStatus);
export const updateAdministratorStatusSuccess = createSuccess(constants.updateAdministratorStatus);
export const updateAdministratorStatusFailure = createFailure(constants.updateAdministratorStatus);

export const deleteAdministratorRequest = createRequest(constants.deleteAdministrator);
export const deleteAdministratorSuccess = createSuccess(constants.deleteAdministrator);
export const deleteAdministratorFailure = createFailure(constants.deleteAdministrator);

export const requestAdministrators = administratorsRequest;
export const requestAdministrator = administratorRequest;
export const createAdministrator = createAdministratorRequest;
export const updateAdministrator = updateAdministratorRequest;
export const updateAdministratorStatus = updateAdministratorStatusRequest;
export const deleteAdministrator = deleteAdministratorRequest;
